import { useCallback } from "react";

import ACL_RELATIONSHIPS from "acl-relationships";
import Authorized from "components/Authorized";
import BaseTableV3 from "components/BaseTableV3/BaseTableV3";
import SourceStatusForm from "components/forms/SourceStatusForm";
import { getNextQueryParams } from "components/helpers";
import FormDialog from "components/modals/FormDialog";
import SourceStatusesService from "services/SourceStatus";
import {
  invalidateSourceStatusesQuery,
  useSourceStatusesTable,
} from "hooks/useSourceStatusesTable";

export const SOURCE_STATUSES_TABLE_CONSTANTS = {
  tableName: "source_status",
  queryKey: "source-statuses",
  header: "Source Statuses",
  headerIcon: "building",
  className: null,
  exportTableName: null,
};

const CREATE_ACLS = [ACL_RELATIONSHIPS.sourceStatus.create];

const SourceStatusesTableV3 = () => {
  const { columns } = useSourceStatusesTable();

  const fetchSourceStatuses = useCallback(
    async queryParams => {
      try {
        const nextQueryParams = getNextQueryParams(queryParams, columns);
        const response = await SourceStatusesService.getTable(nextQueryParams);

        return response;
      } catch (error) {
        console.error("Error fetching source statuses:", error);
        throw error;
      }
    },
    [columns]
  );

  return (
    <BaseTableV3
      columns={columns}
      headerIcon={SOURCE_STATUSES_TABLE_CONSTANTS.headerIcon}
      header={SOURCE_STATUSES_TABLE_CONSTANTS.header}
      tableName={SOURCE_STATUSES_TABLE_CONSTANTS.tableName}
      queryKey={SOURCE_STATUSES_TABLE_CONSTANTS.queryKey}
      className={SOURCE_STATUSES_TABLE_CONSTANTS.className}
      fetchData={fetchSourceStatuses}
      invalidateData={invalidateSourceStatusesQuery}
      createButton={
        <Authorized permissions={CREATE_ACLS}>
          <FormDialog
            FormComponent={SourceStatusForm}
            modelType="Source Status"
            onSuccess={invalidateSourceStatusesQuery}
          />
        </Authorized>
      }
      enableSearch
      enableSettings
    />
  );
};

export default SourceStatusesTableV3;
